export const accessTokenInfo = () => {
    const accessToken = 'SAMPLE'//
    localStorage.setItem('accessToken', accessToken)
    
    let accessInfo = {
         headers: {'X-DQ-ACCESS-TOKEN': accessToken}
    };

    return accessInfo
}


// WEBPACK FOOTER //
// ./src/store/accessToken.js